module.exports = __webpack_public_path__ + "img/img_020@2x.fe0b456f.png";